module.exports = __webpack_public_path__ + "static/media/26UNRWA20.6cdf8015.jpg";